import { render, staticRenderFns } from "./Confrontation.vue?vue&type=template&id=34834889"
import script from "./Confrontation.ts?vue&type=script&lang=ts&external"
export * from "./Confrontation.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports